import type { JobPostingEntitlement, PerformanceBasedEntitlement } from '../../reducers/entitlement/entitlement'
import type { JobCompanyForm, JobCriteriaForm, JobDescriptionForm } from '../../../schema/job'

export const JOB_CREATE = 'job/CREATE'
export const JOB_SUBMIT_CRITERIA = 'job/SUBMIT_CRITERIA'
export const JOB_SUBMIT_DESCRIPTION = 'job/SUBMIT_JOB_DESCRIPTION'
export const JOB_SUBMIT_COMPANY_INFO = 'job/SUBMIT_JOB_COMPANY_INFO'
export const JOB_SUBMIT = 'job/SUBMIT'

export type Product = JobPostingEntitlement | PerformanceBasedEntitlement

export interface JobCreateAction {
  type: typeof JOB_CREATE
  product: Product
}
export const createJob = ({ product }: { product: JobCreateAction['product'] }): JobCreateAction => ({
  product,
  type: JOB_CREATE,
})

export interface JobSubmitCriteriaAction {
  type: typeof JOB_SUBMIT_CRITERIA
  payload: {
    data: JobCriteriaForm
    jobId: string
  }
}
export const submitJobCriteria = (payload: JobSubmitCriteriaAction['payload']): JobSubmitCriteriaAction => ({
  type: JOB_SUBMIT_CRITERIA,
  payload,
})
export interface JobSubmitDescriptionAction {
  type: typeof JOB_SUBMIT_DESCRIPTION
  payload: {
    data: JobDescriptionForm
    jobId: string
  }
}

export const submitJobDescription = (payload: JobSubmitDescriptionAction['payload']): JobSubmitDescriptionAction => ({
  type: JOB_SUBMIT_DESCRIPTION,
  payload,
})

export interface JobSubmitCompanyInfoAction {
  type: typeof JOB_SUBMIT_COMPANY_INFO
  payload: {
    data: JobCompanyForm
    jobId: string
  }
}
export const submitJobCompanyInfo = (payload: JobSubmitCompanyInfoAction['payload']): JobSubmitCompanyInfoAction => ({
  type: JOB_SUBMIT_COMPANY_INFO,
  payload,
})

type JobSubmitActionPayload = {
  jobId: string
  conversions: number
}

export interface JobSubmitAction {
  type: typeof JOB_SUBMIT
  payload: JobSubmitActionPayload
}
export const submitJob = (payload: JobSubmitAction['payload']): JobSubmitAction => ({
  type: JOB_SUBMIT,
  payload,
})

export type JobActions =
  | JobCreateAction
  | JobSubmitCriteriaAction
  | JobSubmitDescriptionAction
  | JobSubmitCompanyInfoAction
  | JobSubmitAction
